// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Loader-module-loader-1-SJ0{height:100%;background-color:var(--des-color-fill-control-base);position:absolute;top:0;inset-inline:0;z-index:5;display:flex;justify-content:center;align-items:center}", ""]);
// Exports
exports.locals = {
	"loader": "Loader-module-loader-1-SJ0"
};
module.exports = exports;
